import Skeleton from '#/components/Skeleton';
import useTotalPortfolioValue, {
  useTotalPortfolioValueIsLoading,
} from '#/data/useTotalPortfolioValue';
import formatUnits from '#/utils/formatUnits';
import { ethers } from 'ethers';

export function PortfolioTotalValue() {
  const isLoading = useTotalPortfolioValueIsLoading();
  const totalAsBigNumber = useTotalPortfolioValue();

  return (
    <Skeleton
      isLoading={isLoading}
      className="text-3xl @3xl/main:text-4xl w-64 inline-block align-middle"
    >
      <p className="font-bold text-gray-800 text-3xl @3xl/main:text-4xl dark:text-gray-400 inline-block align-middle">
        ${ethers.utils.commify(formatUnits(totalAsBigNumber, 8, 2))}
      </p>
    </Skeleton>
  );
}
